import React from 'react';
import { motion } from 'framer-motion';

const itemVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0 },
};

const containerVariants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.1 },
  },
};

const springTransition = { type: 'spring', stiffness: 90, damping: 16, mass: 0.9 };

export const Reveal = ({ children, as = 'div', className, delay = 0 }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      variants={itemVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }}
      transition={{ ...springTransition, delay }}
    >
      {children}
    </MotionTag>
  );
};

export const RevealGroup = ({ children, className }) => (
  <motion.div
    className={className}
    variants={containerVariants}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.15 }}
  >
    {children}
  </motion.div>
);

export const RevealItem = ({ children, className, as = 'div' }) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag className={className} variants={itemVariants} transition={springTransition}>
      {children}
    </MotionTag>
  );
};

export default Reveal;
